module.exports = function (angular, config) {
    return function ($scope, $state) {

    };

};